export default __webpack_public_path__ + "static/review-img-sm-6482030f292acd0276bcbfd82b792a24.png";